import React from 'react';

import { Button, Space, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

interface IProps {
  handleClick: () => void;
}

export const NoResult: React.FC<IProps> = ({ handleClick }) => {
  const isMobile = useIsMobile();

  return (
    <Space direction={'vertical'} align={'center'} className={'h-mt-40 h-pl-20 h-pr-20'}>
      <Typography.Heading level={4} className={'h-mt-24 h-mb-24'}>
        Нет подходящих отзывов
      </Typography.Heading>
      <Button size={44} variant={'outlined'} onClick={handleClick} block={isMobile}>
        Сбросить фильтры
      </Button>
    </Space>
  );
};
